import "../settings.css";
import { useTranslation } from "react-i18next";
import SideBar from "../Components/SideBar/SideBar";
import NotificationEmailManager from "./NotificationEmailManager";

function EmailConfigSettings() {
  const { t } = useTranslation("settings");
  return (
    <div className="parent_wraper">
      <SideBar active="3_2" />
      <div className="dash_table_wrapper">
        <div className="flex items-center justify-between px-1 mb-6">
          <h2 className="text-lg font-semibold text-ui-text m-0">
            {t("sidebar.items.emailConfig")}
          </h2>
        </div>
        <NotificationEmailManager className="max-w-lg" />
      </div>
    </div>
  );
}

export default EmailConfigSettings;
